<div content-chip>
    <fa-icon class="icon" [icon]="iconExcla"></fa-icon>
    <p class="text" [class.italicType]="typeText == 'italic'">
        {{text}}
    </p>
</div>